import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { useBoolean } from 'react-use-boolean';
import { DateRangePicker, DateRangeValue } from './DateRangePicker';
import { FilterClearButton } from './FilterClearButton';
import { FilterLayout } from './FilterLayout';
import { useFilterContext } from './FilterContext';
import { DateFilter } from './customFilters';

export interface DateRangeFilterProps {
  label: string;
  columnId: string;
  labelStart: string;
  labelEnd: string;
}

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({ label, columnId, ...props }) => {
  const [open, actions] = useBoolean();

  const { setFilter, getFilterValue } = useFilterContext();

  const filter = getFilterValue(columnId);

  const isActive = filter?.start || filter?.end;

  const onSelectDate = (dateType: keyof DateFilter) => (value: DateRangeValue) =>
    setFilter(columnId, (prev: DateFilter) => ({
      ...prev,
      [dateType]: value,
    }));

  const onClearClick = () => {
    setFilter(columnId, undefined);
    actions.off();
  };

  return (
    <FilterLayout
      label={label}
      ariaControls='datepicker'
      isActive={isActive}
      open={open}
      openActions={actions}
    >
      <Box padding='5px'>
        <Grid container alignItems='center'>
          <Grid>
            <DateRangePicker
              selectedStartDate={filter?.start}
              selectedEndDate={filter?.end}
              onSelectEndDate={onSelectDate('end')}
              onSelectStartDate={onSelectDate('start')}
              {...props}
            />
          </Grid>
          <Grid>
            <FilterClearButton onClick={onClearClick} isActive={isActive}>
              Clear
            </FilterClearButton>
          </Grid>
        </Grid>
      </Box>
    </FilterLayout>
  );
};
